import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { bool, node } from 'prop-types';

import { getAuth0RedirectUri } from '../../util/auth0Env';
import { persistAuth0AppState } from '../../util/auth0FlexSession';

/**
 * Wraps the client app with Auth0Provider when domain + client ID are set.
 * Used only in ClientApp (browser). ServerApp does not use this — Auth0 runs on the client.
 *
 * redirect_uri must exactly match an Allowed Callback URL in the Auth0 Application.
 * Defaults to REACT_APP_MARKETPLACE_ROOT_URL (same origin your users use in the browser).
 */
const Auth0ProviderMaybe = props => {
  const { children, skipProvider = false } = props;
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = getAuth0RedirectUri();

  if (skipProvider || !domain || !clientId || !redirectUri) {
    return <>{children}</>;
  }

  const onRedirectCallback = appState => {
    persistAuth0AppState(appState);
    if (typeof window !== 'undefined') {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderMaybe.propTypes = {
  children: node.isRequired,
  skipProvider: bool,
};

export default Auth0ProviderMaybe;
